import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgMaterialModule } from '@principle-theorem/ng-material';
import { NgPrincipleModule } from '@principle-theorem/ng-principle';
import { NgPrincipleSharedModule } from '@principle-theorem/ng-principle-shared';
import { NgSharedModule } from '@principle-theorem/ng-shared';
import { BrandsModule } from '../settings/brands/brands.module';
import { PracticesModule } from '../settings/practices/practices.module';
import { InfrastructureTestsComponent } from './infrastructure-tests.component';

@NgModule({
  declarations: [InfrastructureTestsComponent],
  imports: [
    NgPrincipleSharedModule,
    NgPrincipleModule,
    NgSharedModule,
    NgMaterialModule,
    RouterModule,
    PracticesModule,
    BrandsModule,
  ],
})
export class TestPagesModule {}
